import { reduce } from 'lodash';

// This composable is responsible for fetching the data for th
import { useScenarioProductsStore } from '@/stores/scenario-products';
import { useClusteringStore } from '@/stores/clustering';
import { useScenarioCdtsStore } from '@/stores/scenario-cdts';
import { useFurnitureStore } from '@/stores/furniture';

import modellingTypeOptions from '@enums/product-modelling-types';

export function useProductModelling() {
  const scenarioProductsStore = useScenarioProductsStore();
  const clusteringStore = useClusteringStore();
  const cdtStore = useScenarioCdtsStore();
  const furnitureStore = useFurnitureStore();

  const fetchData = async () => {
    const [clusteredProductData] = await Promise.all([
      scenarioProductsStore.fetchScenarioProductsWithClusters(),
      clusteringStore.fetchScenarioClusters(),
      // only fetch cdts that have been selected
      cdtStore.fetchScenarioCdts({ params: { selected: true } }),
      furnitureStore.fetchScenarioFurniture(),
    ]);

    const { existingProductsWithClusters, productsWithoutParents } = reduce(
      clusteredProductData,
      (acc, d) => {
        if (!d.isNewProduct) acc.existingProductsWithClusters.push(d);
        if (!d.parentProduct) acc.productsWithoutParents.push(d);
        return acc;
      },
      { existingProductsWithClusters: [], productsWithoutParents: [] }
    );

    return {
      clusteredProductData,
      existingProductsWithClusters,
      productsWithoutParents,
    };
  };

  function isProductEstablished(modellingType, salesConfidenceScore) {
    // if a product has not been modelled yet, derive if it's established from its sales confidence score (should be 1)
    // We don't want to always just check this score, as some products might be established in cluster A but not in cluster B
    if (!modellingType) return salesConfidenceScore === 1;

    // otherwise, use the modelling type
    return modellingType === modellingTypeOptions.modellingTypes.established;
  }

  return { fetchData, isProductEstablished };
}
